import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { MenuComponent } from './layout/menu/menu.component';
import { CdkTableModule } from '@angular/cdk/table';
import { MatIconModule } from '@angular/material';
import { SharedModule } from './shared/shared.module';

import localePt from '@angular/common/locales/pt';

import {HashLocationStrategy, LocationStrategy, registerLocaleData} from '@angular/common';
import {LoginService} from './login/login.service';
import {AuthGuard} from './guards/auth.guard';
import {Error404Component} from './guards/error404/error404.component';
import {NgxMaskModule} from 'ngx-mask';
import {BlockUIModule} from 'ng-block-ui';
import {NgProgressModule} from 'ngx-progressbar';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { TokenInterceptorService } from './token-interceptor.service';


registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    MenuComponent,
    Error404Component
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    CdkTableModule,
    MatIconModule,
    NgProgressModule,
    BlockUIModule.forRoot(),
    NgxMaskModule.forRoot(),
    SharedModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptorService,
        multi:true
    },
    LoginService, AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
